var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62054 3.14567C5.62054 2.61999 5.6079 2.26953 6.13359 2.26953L16.6473 2.26953C17.173 2.26953 17.5234 2.61999 17.5234 3.14567C17.5234 3.67136 17.173 4.02182 16.6473 4.02182L6.13359 4.02181C5.6079 4.02181 5.62054 3.67136 5.62054 3.14567Z",
    fill: "url(#paint0_linear_3264_41371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000372448 3.14567C-0.000372425 2.61999 0.350085 2.26953 0.87577 2.26953L2.62805 2.26953C3.15374 2.26953 3.29687 2.61999 3.29687 3.14567C3.29687 3.67136 3.15374 4.02182 2.62805 4.02182L0.87577 4.02182C0.350085 4.02182 -0.000372471 3.67136 -0.000372448 3.14567Z",
    fill: "url(#paint1_linear_3264_41371)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5338 9.28142C14.5338 8.75573 14.3693 8.40527 14.895 8.40527L16.6473 8.40527C17.173 8.40527 17.5234 8.75573 17.5234 9.28142C17.5234 9.8071 17.173 10.1576 16.6473 10.1576L14.895 10.1576C14.3693 10.1576 14.5338 9.8071 14.5338 9.28142Z",
    fill: "url(#paint2_linear_3264_41371)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1433e-05 9.28141C3.14559e-05 8.75573 0.350489 8.40527 0.876174 8.40527L11.3899 8.40527C11.9156 8.40527 11.7843 8.75573 11.7843 9.28141C11.7843 9.8071 11.9156 10.1576 11.3899 10.1576L0.876174 10.1576C0.350489 10.1576 3.141e-05 9.8071 3.1433e-05 9.28141Z",
    fill: "url(#paint3_linear_3264_41371)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1269 9.27934C10.1269 7.56991 11.4341 6.2627 13.1435 6.2627C14.8529 6.2627 16.1602 7.56991 16.1602 9.27934C16.1602 10.9888 14.8529 12.296 13.1435 12.296C11.4341 12.296 10.1269 10.9888 10.1269 9.27934ZM14.1491 9.27934C14.1491 8.67601 13.7468 8.27379 13.1435 8.27379C12.5402 8.27379 12.138 8.67601 12.138 9.27934C12.138 9.88267 12.5402 10.2849 13.1435 10.2849C13.7468 10.2849 14.1491 9.88267 14.1491 9.27934Z",
    fill: "url(#paint4_linear_3264_41371)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2342 3.14657C1.2342 1.36351 2.59772 -2.15481e-07 4.38077 -1.37541e-07C6.16383 -5.96011e-08 7.52734 1.36351 7.52734 3.14657C7.52734 4.92963 6.16383 6.29314 4.38077 6.29314C2.59772 6.29314 1.2342 4.92963 1.2342 3.14657ZM5.42963 3.14657C5.42963 2.51726 5.01009 2.09771 4.38077 2.09771C3.75146 2.09771 3.33192 2.51726 3.33192 3.14657C3.33192 3.77588 3.75146 4.19543 4.38077 4.19543C5.01009 4.19543 5.42963 3.77589 5.42963 3.14657Z",
    fill: "url(#paint5_linear_3264_41371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3264_41371",
    x1: 17.5234,
    y1: 3.14567,
    x2: 5.62052,
    y2: 3.14567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3264_41371",
    x1: 3.29687,
    y1: 3.14567,
    x2: -0.000372448,
    y2: 3.14567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3264_41371",
    x1: 17.5234,
    y1: 9.28142,
    x2: 14.5094,
    y2: 9.28142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3264_41371",
    x1: 11.7988,
    y1: 9.28142,
    x2: 0.000031433,
    y2: 9.28141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3264_41371",
    x1: 16.1602,
    y1: 9.27934,
    x2: 10.1269,
    y2: 9.27934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3264_41371",
    x1: 7.52734,
    y1: 3.14657,
    x2: 1.2342,
    y2: 3.14657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationColor);
export default __webpack_public_path__ + "static/media/Location-color.bd76d3bdd5d5220040b7ee699182e8ee.svg";
export { ForwardRef as ReactComponent };